module.exports = __webpack_public_path__ + "img/90.46483f2b.jpg";